/* eslint-disable import/prefer-default-export */
export const ORDER_INTEGRATION = {
    strata: 1, direct: 2, email: 3,
  };
  